import { Select } from 'antd'
import { memo, useEffect, useMemo, useState } from 'react'
import { SearchReviewType } from '../constants/constants'
import useSearchReviews from '../hooks/useSearchReviews'
import { SearchReview } from '../store/reducers/searchReviewReducer'

interface SelectOption {
  label: string
  value: string
}

interface SelectSearchReviewProps {
  onChange: (value: SearchReview | undefined) => void
  style?: Object
  selectedType?: SearchReviewType
}

const SelectSearchReview = memo(
  ({ onChange, style, selectedType }: SelectSearchReviewProps) => {
    const [searchReviews, setSearchReviews] = useState<SearchReview[]>([])

    const { getSearchReviewListOwnedOnly } = useSearchReviews({
      preventFetch: true,
    })

    const options: SelectOption[] | undefined = useMemo(
      () =>
        searchReviews
          ?.filter(
            (searchReview: SearchReview) =>
              !!searchReview.id &&
              (!selectedType || searchReview.reviewType === selectedType)
          )
          .map((searchReview: SearchReview) => ({
            label: searchReview.title || '',
            value: searchReview.id || '',
          })),
      [searchReviews, selectedType]
    )
    const [loading, setLoading] = useState(true)
    const [selectedValue, setSelectedValue] = useState('')

    const handleChange = (value: string) => {
      setSelectedValue(value)
      if (searchReviews) {
        onChange(
          searchReviews.find(
            (searchReview: SearchReview) => searchReview.id === value
          )
        )
      }
    }

    useEffect(() => {
      getSearchReviewListOwnedOnly()
        .then((response: SearchReview[]) => {
          setSearchReviews(response)
        })
        .catch((error) => {
          console.error('axios fetch error', error)
        })
        .finally(() => {
          setLoading(false)
        })
    }, [getSearchReviewListOwnedOnly])

    return (
      <Select
        style={style}
        onChange={handleChange}
        value={selectedValue}
        options={options}
        loading={loading}
      />
    )
  }
)

export default SelectSearchReview
